<template>
  <div class="pl-8 pr-8">

    <!-- CURRENT STOCK LEVEL -->
    <v-row class="pa-4 align-center justify-center display-1 border-b--thin">
      <div v-if="current_inventory.length > 0">
        <c-ms-ii
        :metric_definition="archive_item.definition" 
        :realValue="totalInStock"
        :key="(archive_item.definition || {}).id"
        labelMode
        ></c-ms-ii>
      </div>

      <div v-else>
        OUT OF STOCK
      </div>

    </v-row>
    <!-- CURRENT STOCK LEVEL -->

    <v-row class="justify-center mt-4">
      <v-btn text :color="viewMode === 0 ? 'color1' : ''"
      @click.stop="viewMode = 0">
        <v-icon>mdi-information-variant</v-icon>
        &nbsp;INFO
      </v-btn>
      <v-btn text :color="viewMode === 1 ? 'color1' : ''"
      @click.stop="viewMode = 1">
        <v-icon>mdi-sticker-emoji</v-icon>
        &nbsp;LABEL
      </v-btn>
    </v-row>

    <v-card v-if="viewMode === 0" class="backgroundCard pa-4 ma-3">

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ archive_item }}
            </span>
          </div>
        </v-card>
      </v-menu>
      <div class="headline pa-2">
        <span>
          {{ (archive_item.definition || {}).name }}
        </span>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
            icon
            small
            v-on="on"
            @click.stop="$router.push('/inventory/inventory-definition/view/' + archive_item.definition.id)"
            >
              <v-icon small>mdi-application-import</v-icon>
            </v-btn>
          </template>
          <span>View this item in the main view</span>
        </v-tooltip>

      </div>
      <div class="pa-2">
        <v-row class="align-center mb-4">
          <img class="mr-3" src="@/assets/img/illustrations/cardboard-box.png" height="40px" width="40px" />
          <div>
            <div v-if="current_inventory.length > 0">
              <div class="overline">Remaining stock</div>
              <c-ms-ii
              :metric_definition="archive_item.definition" 
              :realValue="totalInStock"
              :key="(archive_item.definition || {}).id"
              labelMode
              ></c-ms-ii>
            </div>

            <v-chip v-else
            color="pink"
            x-small
            text-color="white">
              OUT OF STOCK
            </v-chip>

          </div>
        </v-row>
        <div>
          <span>
            <span class="textSecondary--text">
            RID:
            </span>
            <span class="ml-1">{{ archive_id }}</span>
          </span>
        </div>
        <div>
          <span v-if="archive_item.batch_number">
            <span class="textSecondary--text">
            Batch:
            </span>
            {{ archive_item.batch_number }}
          </span>
        </div>
        <div>
          <v-chip v-if="hasExpired"
          color="pink"
          x-small
          text-color="white">
            EXPIRED
          </v-chip>
          <div v-if="archive_item.expiry_date" class="caption">
            {{ hasExpired? 'expired' : 'expires' }} {{ expiryDateHuman }} <br /> ({{ expiryDate }})
          </div>
        </div>
      </div>

    </v-card>

    <v-card v-else class="pa-4 ma-3">
      <div>
        {{ (archive_item.definition || {}).name }}
      </div>
      <div>
        RID: {{ archive_id }}
      </div>
      <div>
        Supplier: {{ archive_item.supplier_name }}
      </div>
      <div>
        Batch: {{ archive_item.batch_number }}
      </div>
      <div>
        Expiry: {{ expiryDate }}
      </div>
      <div>
        Internal code: {{ archive_item.internal_code }}
      </div>
      <div>
        Approved by:
      </div>
      <div>
        Opened:
      </div>
    </v-card>

    <!-- ANALYSIS -->
    
    <v-row no-gutters>
      <v-col sm="4">
        <v-card class="elevation-0 ma-1 pa-2">
          <div class="overline mb-4">Initial entry</div>
          <div>
            <c-ms-ii
            :metric_definition="archive_item.definition" 
            :realValue="(items[0] || {}).quantity"
            :key="(archive_item.definition || {}).id"
            labelMode
            ></c-ms-ii>
          </div>
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card class="elevation-0 ma-1 pa-2">
          <div class="overline mb-4">TIMELINE TRAIL</div>
          <div>
            <c-ms-ii
            :metric_definition="archive_item.definition" 
            :realValue="timelineDebits"
            :key="(archive_item.definition || {}).id"
            labelMode
            ></c-ms-ii>
          </div>
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card class="elevation-0 ma-1 pa-2">
          <div class="overline mb-4">Difference</div>
          <div>
            <v-icon v-if="timelineDebits === totalInStock">mdi-check</v-icon>
            <span v-else>
              <v-icon>mdi-close</v-icon>
              <c-ms-ii
              :metric_definition="archive_item.definition" 
              :realValue="totalInStock - timelineDebits"
              :key="(archive_item.definition || {}).id"
              labelMode
              ></c-ms-ii>
              <v-tooltip v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)" bottom open-delay="200">
                <template v-slot:activator="{ on }">
                  <v-btn
                  v-on="on"
                  icon
                  small
                  color="primary"
                  @click="refundTimelineDifference"
                  >
                    <v-icon>mdi-arrow-up</v-icon>
                  </v-btn>
                </template>
                <span>Refund difference</span>
              </v-tooltip>

            </span>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- ANALYSIS -->

    <v-card 
    v-if="current_inventory.length > 0"
    class="elevation-0 ma-2 mt-8">
      <v-row class="pa-2 display-1">
        Inventory
      </v-row>
      <table 
      class="final-table th-no-padding lines-b pointer hover full-width">
        <colgroup ref="colgroup1">
          <col width="30px">
          <col width="30px">
          <col width="30px">
        </colgroup>

        <tr class="unselectable">
          <c-table-header
          title="Code"
          code="code"
          class="sticky"
          :filters="filters">
          </c-table-header>

          <c-table-header
          title="Location"
          code="location"
          class="sticky"
          :filters="filters">
          </c-table-header>

          <c-table-header
          title="Quantity"
          code="quantity"
          :filters="filters">
          </c-table-header>
        </tr>

        <inventory-row
        v-for="item in current_inventory" 
        :key="item.id"
        :item="item"
        @editQuantity="editQuantity"
        ></inventory-row>

      </table>
    </v-card>
    
    
    <v-card class="elevation-0 ma-2 mt-8">
      <v-row class="pa-2 display-1">
        Transactions
      </v-row>
      <table class="final-table th-no-padding lines-b pointer hover full-width">
        <colgroup ref="colgroup1">
          <col width="15px">
          <col width="30px">
          <col width="30px">
          <col width="30px">
        </colgroup>

        <tr class="unselectable">
          <th></th>
          <th></th>
          <th></th>
          <th>
            <c-preffered-metric-selector :sid.sync="prefferedSid">
            </c-preffered-metric-selector>
          </th>
    
        </tr>

        <row
        v-for="item in items" 
        :key="item.id"
        :item="item"
        :definition="archive_item.definition"
        :prefferedSid="prefferedSid"
        ></row>

      </table>
    </v-card>
    
    <!-- DIALOGS -->
    <edit-quantity-dialog ref="editQuantityDialog" @onUpdate="loadAPI(archive_id)"></edit-quantity-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import Row from './row'
import InventoryRow from './inventory-row'
import EditQuantityDialog from '@/components/v/inventory/edit-inv-quantity-dialog'

export default {
  props: ['archive_id'],
  components: {
    Row,
    InventoryRow,
    EditQuantityDialog
  },
  data () {
    return {
      viewMode: 0,
      items: [],
      archive_item: {},
      prefferedSid: null,
      current_inventory: [],
      filters: {
        rowsPerPage: 10,
        sortCol: 'code',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      }
    }
  },
  watch: {
    archive_id (nv) {
      this.loadAPI(nv)
    }
  },
  computed: {
    timelineDebits () {
      return this.items.reduce((a, b) => +a + +b.quantity, 0)
    },
    totalInStock () {
      return this.current_inventory.reduce((a, b) => +a + +b.quantity, 0)
    },
    expiryDate () {
      if (this.$moment.utc(this.archive_item.expiry_date).isValid()) {
        return this.$moment(this.archive_item.expiry_date).format('DD MMM YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.archive_item.expiry_date).isValid()) {
        return this.$moment.utc(this.archive_item.expiry_date).fromNow()
      }
      return ''
    },
    hasExpired () {
      return this.$moment.utc(this.archive_item.expiry_date).isBefore()
    }
  },
  methods: {
    refundTimelineDifference () {
      this.$axios.post(`/inventory-archive/${this.archive_id}/timeline-refund`)
      .then(response => {
          console.log(response)
          this.loadAPI(this.archive_id)
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    editQuantity (id) {
      this.$refs.editQuantityDialog.open(id)
    },
    loadAPI (id) {
      axios.all([
        this.$axios.get(`/inventory-archive/${id}/timeline`),
        this.$axios.get(`/inventory/archive-id/${id}`)
        ])
        .then(axios.spread((_timeline, _inventory) => {
          this.items = _timeline.data.timeline
          this.archive_item = _timeline.data.archive_item
          this.current_inventory = _inventory.data.rows
        }))
        .catch(error => this.$root.$errorSnackbar(error))
    }
  },
  created () {
    this.loadAPI(this.archive_id)
  }
}
</script>